import {useRef, useState, useEffect} from 'react';
import {ReactComponent as SearchIcon} from 'assets/icons/search.svg';
import {ReactComponent as CloseIcon} from 'assets/icons/close.svg';
import {useIntl} from 'react-intl';

const TextField = ({settings, onChange, onKeyPress, ...rest}) => {
  const intl = useIntl();
  const input = useRef(null);
  const {
    name,
    type,
    placeholder,
    searchButton = false,
    defaultValue,
    state,
    wrapperClasses = '',
    clearButton = false,
    disabled = false,
  } = settings || {};

  const [displayClear, setClearDisplay] = useState(false);

  useEffect(() => {
    if (clearButton) {
      if (state && state[name]) {
        setClearDisplay(true);
      }
      else {
        setClearDisplay(false);
      }
    }
  }, [state]);

  if (!name) {
    return '';
  }

  const renderSearchButton = () => {
    if (!searchButton) {
      return '';
    }

    return (
      <SearchIcon />
    );
  };

  const renderClearButton = () => {
    if (!clearButton) {
      return '';
    }

    return (
      <button className="button--clear" onClick={() => {
        onChange({
          target: {
            name,
            type,
            value: '',
          },
          submit: true,
        });
        input.current.focus();
      }}>
        <span className="visually-hidden">{intl.formatMessage({id: 'Input.Text.ClearValue'})}</span>
        <CloseIcon />
      </button>
    );
  };

  return (
    <div className={`${wrapperClasses}${searchButton || clearButton ? ' text-field-with-search relative' : ''}`}>
      <input ref={input}
             type="text"
             name={name}
             defaultValue={defaultValue}
             value={state && state.hasOwnProperty(name) ? state[name] : ''}
             placeholder={placeholder ? intl.formatMessage({id: placeholder}) : ''}
             onChange={onChange}
             onKeyPress={(event) => {
               if (typeof onKeyPress === 'function') {
                 onKeyPress(event)
               }
             }}
             disabled={disabled}
             {...rest}
      />
      {displayClear ? renderClearButton() : ''}
      {renderSearchButton()}
    </div>
  );
};

export default TextField;
